import { splunk } from '@fs/zion-splunk-logger'
import { differenceInSeconds } from '@fs/zion-locale/date-fns'
import getCollectionIds from './getCollectionIds'

// Splunk logging for same-type spam (repeated pressing of the same button, regardless of the time interval in which the presses happened)
export const logSameTypeSpam = (cisId, collectionIds, consecutiveSpamEpisodes, originalValues, spamDuration, type) => {
  const logObject = {
    cisId,
    collectionIds,
    consecutiveSpamEpisodes,
    message: `${type} same-type spamming on quick name review`,
    spamDurationInSeconds: spamDuration,
  }
  if (originalValues) logObject.originalValues = originalValues
  splunk.log(logObject)
}

// Get the most recent tasks that are all the same type as the newest task
export function getSameTypeTasks(taskCache, type) {
  if (!taskCache.current) return []
  return [
    ...(taskCache.current?.filter((task) => {
      return task.actionType === type
    }) || []),
  ]
}

// Bundle up & format the originalValues for the log
const getOriginalValues = (tasks) => {
  const originalValues = tasks.map((task) => {
    return task.originalValue
  })
  return originalValues.join(', ')
}

export default function checkForSameTypeSpam({
  cisId,
  consecutiveSpamEpisodes,
  incrementConsecutiveSpam,
  taskCache,
  threshold,
  type,
}) {
  // No point checking for spam if there aren't enough completed tasks yet
  if (taskCache?.current?.length < threshold) return

  const mostRecentTask = taskCache?.current?.slice(-1)?.[0]
  const sameTypeTasks = getSameTypeTasks(taskCache, type)
  const originalValues = type === 'match' ? null : getOriginalValues(sameTypeTasks)

  // Determine how much time elapsed between the first and last task in the spam episode
  const spamDuration = differenceInSeconds(sameTypeTasks.slice(-1)[0].timestamp, sameTypeTasks[0].timestamp)

  // If the user reached the spam threshold, log it and clear the cache
  if (sameTypeTasks.length === threshold) {
    incrementConsecutiveSpam(type)

    getCollectionIds(sameTypeTasks)
      .then((collectionIds) => {
        logSameTypeSpam(
          cisId,
          collectionIds,
          consecutiveSpamEpisodes?.current.count,
          type !== 'match' && { originalValues },
          spamDuration,
          mostRecentTask.actionType
        )
      })
      .catch((error) => console.error('Error logging garbage spam:', error))

    taskCache.current = []
  }
}
